<template>
    <MobileLayout :showTopBar="false">
		<!-- 顶部大 Logo -->
		<div>
			<img :src="brandLogo" alt="denHolm" class="ms-logo" />
		</div>
		
        <div class="ms-wrap">
            
            <!-- 标题：距 Logo 140px -->
            <div class="ms-header">Enquiry List ({{ totalCount }})</div>

            <!-- 介绍文字：距离标题 107px，最大宽度 226px -->
            <div class="ms-intro">
				<p>Fill in the form below,</p>
				<p>Mr denHolm</p>
				<p>will be with you shortly.</p>
            </div>

            <!-- 表单：距离介绍文字 100px，输入框间距 34px -->
            <form class="ms-form" @submit.prevent="sendEnquiry">
                <label class="ms-field">
                    <input v-model="form.name" type="text" placeholder="Name" required />
                </label>
                <label class="ms-field">
                    <input v-model="form.email" type="email" placeholder="Email" required />
                </label>
                <label class="ms-field">
                    <input v-model="form.phone" type="text" placeholder="Phone (Optional)" />
                </label>
                <label class="ms-field">
                    <input v-model="form.notes" type="text" placeholder="Additional Notes (Optional)" />
                </label>
            </form>

            <!-- 提交按钮底部区域：距离底部菜单栏上方 36px -->
            <div class="ms-submit">
				<button class="ms-submit-btn" type="button" @click="$router.back()" style="border:none;margin-right: 10rem;">Back</button>
                <button class="ms-submit-btn" type="button" @click="sendEnquiry" :disabled="submitting" style="margin-left: 10rem;">
                    {{ submitting ? 'Submitting...' : 'Submit' }}
                </button>
            </div>
        </div>
    </MobileLayout>
</template>

<script>
import MobileLayout from '@/components/mobile/MobileLayout.vue'
import { showMessage } from '@/config/message'
import { getUser } from '@/config/auth'
import { getCartItems, submitEnquiry } from '@/api/Enquiry'
import { getLocalCart, clearLocalCart } from '@/utils/localCart'

// ★ 引入顶部 Logo
const brandLogo = require('@/assets/logo_b.png')

export default {
    name: 'MobileEnquirySub',
    components: {
        MobileLayout
    },
    data() {
        return {
            totalCount: 0,
            cartItems: [],
            loggedInUser: null,
            submitting: false,
            brandLogo, // ★ 注入到 data
            form: {
                name: '',
                email: '',
                phone: '',
                notes: ''
            }
        }
    },
    mounted() {
        this.loadUser()
        this.loadCartItems()
    },
    methods: {
        loadUser() {
            const user = getUser()
            this.loggedInUser = user
            if (user) {
                this.form.name = `${user.FirstName || ''} ${user.LastName || ''}`.trim() || user.Email
                this.form.email = user.Email || ''
                this.form.phone = user.Phone || ''
            }
        },
        async loadCartItems() {
            if (this.loggedInUser) {
                try {
                    const items = await getCartItems(this.loggedInUser.UserID)
                    this.cartItems = items
                    this.totalCount = items.length
                } catch (error) {
                    console.error('Failed to load cart items:', error)
                    showMessage('Failed to load enquiry list', 'error')
                }
            } else {
                const localItems = getLocalCart()
                this.cartItems = localItems.map(item => ({
                    ProductID: item.ProductID,
                    IsCustomized: !!item.customizationText,
                    CustomisationText: item.customizationText || ''
                }))
                this.totalCount = localItems.length
            }
        },
        async sendEnquiry() {
            if (!this.form.name || !this.form.email) {
                showMessage('Name and email are required', 'error')
                return
            }
            if (this.cartItems.length === 0) {
                showMessage('No products in enquiry list', 'error')
                return
            }

            const products = this.cartItems.map(item => ({
                ProductID: item.ProductID,
                Quantity: 1,
                CustomisationText: item.IsCustomized ? item.CustomisationText : ''
            }))

            const model = {
                UserID: this.loggedInUser ? this.loggedInUser.UserID : 0,
                Name: this.form.name,
                Email: this.form.email,
                Phone: this.form.phone || '',
                AdditionalNotes: this.form.notes || '',
                Products: products
            }

            this.submitting = true
            try {
                await submitEnquiry(model)
                showMessage('Enquiry sent successfully!', 'success')
                if (this.loggedInUser) {
                    await this.loadCartItems()
                } else {
                    clearLocalCart()
                    this.cartItems = []
                    this.totalCount = 0
                }
                setTimeout(() => {
                    this.$router.push('/m/enquiry')
                }, 1500)
            } catch (error) {
                console.error('Submit enquiry failed:', error)
                showMessage('Failed to submit enquiry', 'error')
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style scoped>
.ms-wrap {
    /* height: calc(100vh - 45rem); */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 57rem; /* 去掉顶部 padding，让 Logo 贴顶 */
    background: #fff;
    color: #000;
    font-family: 'Apercu-Medium', sans-serif;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
	padding-top: 88rem;
}

/* ★ 顶部大 Logo 样式 */
.ms-logo {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
}

.ms-header {
    font-size: 18rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 73rem;  
}

.ms-intro {
    text-align: center;
    font-size: 13rem;
    font-weight: 600;
    max-width: 226rem; /* 限制宽度为 226像素 */
    margin: 0 auto 50rem auto; /* 距下方表单 100像素 */
}

.ms-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4rem;  
}

.ms-field input {
    width: 100%;
    border: none;
    border-bottom: 1rem solid #000;
    padding: 4rem 0;
    font-size: 14rem;
    outline: none;
    color: #000;
    background: transparent;
    font-family: 'Apercu-Medium', sans-serif;
}

.ms-field input::placeholder {
    font-family: 'Apercu-Medium', sans-serif !important;
    color: #bdbdbd;
}

/* ★ 底部固定区域：距黑色菜单栏上方 36像素 */
.ms-submit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 45rem; /* 跨越菜单栏高度（假设菜单栏高 45px） */
    display: flex;
    justify-content: center;
    padding-bottom: 36rem; /* 核心修改：按钮距底栏 36像素 */
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 20%);
    pointer-events: none; /* 穿透背景，让按钮能被点击 */
}

.ms-submit-btn {
    pointer-events: auto; /* 恢复按钮本身可点击 */
    background: #fff;
    border: 1rem solid #000;
    color: #000;
    font-size: 13rem;
    font-weight: 500;
    font-family: 'Apercu-Medium', sans-serif;
   height: 28rem;
       width: 88rem;
    border-radius: 16rem; /* 按钮圆角 16像素 */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.ms-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
</style>